import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

const iconParentId = 'kb-icons';

@Injectable({
  providedIn: 'root',
})
export class IconService {

  private document = inject(DOCUMENT);
  private iconParentElement: HTMLElement;

  public constructor() {
    let iconParentElement = this.document.getElementById(iconParentId);
    if (iconParentElement === null) {
      // cannot use template as that is not populated with ssr
      iconParentElement = this.document.createElement('div');
      iconParentElement.style.display = 'none';
      iconParentElement.id = iconParentId;
      const firstScriptElement = this.document.body.querySelector('script');
      if (firstScriptElement !== null) {
        this.document.body.insertBefore(iconParentElement, firstScriptElement); // ensure that the parent element comes before any script element, to have a continous html parsing phase
      } else {
        this.document.body.appendChild(iconParentElement);
      }
    }
    this.iconParentElement = iconParentElement;
  }

  public registerIcon(name: string, svg: string): string {
    const id = `icon-${name}`;
    if (this.document.getElementById(id) !== null) {
      return id;
    }
    this.iconParentElement.insertAdjacentHTML('beforeend', svg);
    (this.iconParentElement.lastChild as SVGElement).id = id;
    return id;
  }

}
